import { StreamType } from '../../types'
import { RoomAction } from '../constants/enums'
import { authenticated } from '../mfcLogic/auth'
import { getLens } from '../mfcLogic/lens'
import { slugToID } from '../state/internal/users'

// import { SETTINGSSTATE } from '../state/state.settings'
import { eraseCookie, getCookie, setCookie } from '../utilities/cookies'
import { roomAction } from './workerActions'

export const requestClubShowInfo = (id: number) => {
    if (!id) return
    roomAction(RoomAction.CLUBSHOW_INFO, { id })
}

export const requestGroupShow = (slug: string) => {
    const id = slugToID[slug]
    if (!id) return
    getLens()?.Group_Join()
    roomAction(RoomAction.REQUEST_GROUP, { id })
}

export const requestPrivate = (slug: string) => {
    const id = slugToID[slug]
    if (!id) return
    getLens()?.GoPrivate_Join()
    roomAction(RoomAction.REQUEST_PRIVATE, { id })
}

export const requestVoyeur = (slug: string) => {
    const id = slugToID[slug]
    if (!id) return
    getLens()?.Voyeur_Join()
    roomAction(RoomAction.REQUEST_VOYEUR, { id })
}

export const streamPublicShow = (id) => {
    // console.log(`[app-state: room ${id}] ATTEMPTING TO STREAM PUBLIC SHOW`)
    roomAction(RoomAction.STREAM_PUBLIC_SHOW, { id })
}

export const streamClubShow = (id) => {
    getLens()?.Club_Join()
    roomAction(RoomAction.STREAM_CLUBSHOW, { id })
}

const filterLMVandLMVT = (idString: string) => {
    const lmvValue = getCookie('lmv')

    if (!lmvValue) {
        return { lmvt: [], lmv: [] }
    }

    const lmvValueArray = (lmvValue || '').split(',')
    const lmv = lmvValueArray.filter((id) => id !== idString)

    const lmvtValue = getCookie('lmvt')

    const targetIndex = lmvValueArray.findIndex((id) => id === idString)
    const lmvtValueArray = (lmvtValue || '').split(',')
    const lmvt = lmvtValueArray.filter((_, i) => targetIndex !== i)

    return { lmvt, lmv }
}

export const subscribeRoom = (
    id: number,
    options: { streamType?: StreamType; forceVoyeur?: boolean } = {},
) => {
    const { streamType, forceVoyeur } = options
    // console.trace(
    //     `[app-state: room ${id}] SUBSCRIBE ROOM. Stream Type:`,
    //     streamType,
    // )
    roomAction(RoomAction.SUBSCRIBE, { id, streamType, forceVoyeur })

    if (authenticated()) {
        return
    }

    const idString = id + ''

    const { lmvt: existingLMVT, lmv: existingLMV } = filterLMVandLMVT(idString)
    const lmvNew = [idString, ...existingLMV].join(',')

    setCookie('lmv', lmvNew)

    const timestampString = Math.floor(Date.now() / 1000) + ''
    const lmvtNew = [timestampString, ...existingLMVT].join(',')

    setCookie('lmvt', lmvtNew)
}

export const swapRoom = (
    id: number,
    options: {
        unsubscribeStreamType?: StreamType
        subscribeStreamType?: StreamType
    } = {},
) => {
    const { unsubscribeStreamType, subscribeStreamType } = options
    // console.log(
    //     `[app-state: room ${id}] SWAPPING ROOM. Subscribe: ${subscribeStreamType}, Unsubscribe: ${unsubscribeStreamType}`,
    // )

    roomAction(RoomAction.SWAP, {
        unsubscribeStreamType,
        subscribeStreamType,
        id,
    })
}

export const unsubscribeRoom = (
    id: number,
    options: { streamType?: StreamType } = {},
) => {
    const { streamType } = options
    // console.log(
    //     `[app-state: room ${id}] UNSUBSCRIBE ROOM. Stream Type:`,
    //     streamType,
    // )
    roomAction(RoomAction.UNSUBSCRIBE, { id, streamType })

    if (authenticated()) {
        return
    }

    const { lmvt: existingLMVT, lmv: existingLMV } = filterLMVandLMVT(id + '')

    if (existingLMVT.length === 0) {
        eraseCookie('lmvt')
        eraseCookie('lmv')
        return
    }

    setCookie('lmvt', existingLMVT.join(','))
    setCookie('lmv', existingLMV.join(','))
}
